import { CrudModelBase, initialCrudModelBaseState } from '@/shared/models/cruds.models'
import { BillingModalEntityGridDatasource } from '@/modules/billing-module/shared/components/modal-entity/components/grid/config/billing-modal-entity-grid.datasource'

export type BillingModalEntityGridState<R> = CrudModelBase<R, BillingModalEntityGridDatasource<R>>
export const initialBillingModalEntityGridState =
    <R>(): BillingModalEntityGridState<R> => ({
        ...initialCrudModelBaseState()
    })
